import { motion } from 'framer-motion'
import { Bot, MessageCircle, CreditCard, BarChart } from 'lucide-react'

const demoFeatures = [
  { icon: MessageCircle, text: 'Попробуйте диалог с ботом' },
  { icon: CreditCard, text: 'Протестируйте оплату' },
  { icon: BarChart, text: 'Посмотрите аналитику' }
]

export default function DemoSection() {
  return (
    <section className="py-24 bg-gradient-to-br from-blue-600 to-indigo-700 text-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2 className="text-4xl lg:text-5xl font-bold mb-6">
              Попробуйте демо-бот
            </h2>
            <p className="text-xl text-blue-100 mb-8">
              Откройте демо-версию в Telegram и протестируйте все возможности вживую
            </p>

            <ul className="space-y-4 mb-8">
              {demoFeatures.map((feature, index) => (
                <motion.li
                  key={index}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.1, duration: 0.5 }}
                  className="flex items-center gap-3"
                >
                  <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center">
                    <feature.icon className="w-5 h-5" />
                  </div>
                  <span className="text-lg">{feature.text}</span>
                </motion.li>
              ))}
            </ul>

            <motion.a
              href="https://t.me/softrest_bot?start=demo"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="inline-flex items-center gap-3 px-8 py-4 bg-white text-blue-600 rounded-xl font-semibold hover:bg-blue-50 transition-colors shadow-xl"
            >
              <Bot className="w-6 h-6" />
              Открыть демо в Telegram
            </motion.a>

            <p className="mt-4 text-sm text-blue-200">
              Никаких регистраций — просто откройте и начните тестировать
            </p>
          </motion.div>

          {/* Right illustration */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="hidden lg:block"
          >
            <div className="relative">
              {/* Phone mockup */}
              <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/20">
                <div className="bg-gray-900 rounded-2xl p-4 shadow-2xl">
                  <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-700">
                    <Bot className="w-8 h-8 text-blue-400" />
                    <div>
                      <div className="text-sm font-semibold text-white">SoftRest Bot</div>
                      <div className="text-xs text-gray-400">онлайн</div>
                    </div>
                  </div>
                  
                  <div className="space-y-3">
                    <div className="bg-blue-600 text-white p-3 rounded-lg rounded-tl-none text-sm">
                      Привет! Я помогу автоматизировать ваш бизнес
                    </div>
                    <div className="bg-gray-800 text-white p-3 rounded-lg rounded-tr-none text-sm ml-8">
                      Что умеешь?
                    </div>
                    <div className="bg-blue-600 text-white p-3 rounded-lg rounded-tl-none text-sm">
                      Приём заявок, оплата, CRM, аналитика и многое другое!
                    </div>
                  </div>
                </div>
              </div>

              {/* Floating elements */}
              <motion.div
                animate={{ y: [-10, 10, -10] }}
                transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
                className="absolute -top-6 -right-6 bg-white/20 backdrop-blur-sm rounded-xl p-4 border border-white/30"
              >
                <MessageCircle className="w-8 h-8" />
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  )
}
